import {
  Request
} from '../index'

/** 查询车次信息 */
export function kpiBusGetBusList(data = {}) {
  return Request('busmobile/order/getBusList', 'post', undefined, data)
}

/** 查询车次信息(缓存) */
export function kpiBusGetBusListByCache(data = {}) {
  return Request('busmobile/order/getBusListByCache', 'post', undefined, data)
}

/** 汽车票预订填写页信息 */
export function kpiBusLoadBookingInfo(data = {}) {
  return Request('busmobile/order/loadBookingInfo', 'post', undefined, data)
}

/** 审批初始化 */
export function kpiBusCheckReasonCode(data = {}) {
  return Request('busmobile/order/checkReasonCode', 'post', undefined, data)
}

/** 保存订单 */
export function kpiBusSave(data = {}) {
  return Request('busmobile/order/save', 'post', undefined, data)
}

/** 获取订单列表 */
export function kpiBusGetOrderList(data = {}) {
  return Request('busmobile/order/getOrderList', 'post', undefined, data)
}

/** 获取订单详情 */
export function kpiBusGetOrderDetail(data = {}) {
  return Request('busmobile/order/getOrderDetail', 'post', undefined, data)
}

/** 订单取消 */
export function kpiBusCancel(data = {}) {
  return Request('busmobile/order/cancel', 'post', undefined, data)
}

/** 获取退票计算规则 */
export function kpiBusGetRefundRules(data = {}) {
  return Request('refund/getRefundRules', 'post', undefined, data)
}

/** 获取退票费用 */
export function kpiBusGetRefundFee(data = {}) {
  return Request('refund/getRefundFee', 'post', undefined, data)
}

/** 发起退票 */
export function kpiBusSaveRefundOrder(data = {}) {
  return Request('busmobile/refund/saveRefundOrder', 'post', undefined, data)
}

/** 取消退票 */
export function kpiBusRefundCancel(data = {}) {
  return Request('busmobile/refund/cancel', 'post', undefined, data)
}

/** 获取退单详情 */
export function kpiBusGetRefundOrderDetail(data = {}) {
  return Request('busmobile/refund/getRefundOrderDetail', 'post', undefined, data)
}

/** 获取城市接口 */
export function kpiBusCommonQueryCities(data = {}) {
  return Request('busapi/common/queryCities', 'post', undefined, data)
}

/** 根据条件查询城市车站 */
export function kpiBusCommonGetCitiesByKeyWord(data = {}) {
  return Request('busapi/common/getCitiesByKeyWord', 'post', undefined, data)
}

/** 汽车票--获取退票规则 */
export function kpiBusRefundGetRuleDesc(data = {}) {
  return Request('busmobile/refund/getRuleDesc', 'post', undefined, data)
}

/** 汽车票--校验订单是否重复 */
export function kpiBusOrderCheckRepeatBooking(data = {}) {
  return Request('busmobile/order/checkRepeatBooking', 'post', undefined, data)
}

/** 汽车票--校验订单是否重复 */
export function kpiBusOrderDoPay(data = {}) {
  return Request('busmobile/order/doPay', 'post', undefined, data)
}

/** 汽车票--退票初始化 */
export function kpiBusRefundGetRefundTicketInitInfo(data = {}) {
  return Request('busmobile/refund/getRefundTicketInitInfo', 'post', undefined, data)
}

/** 汽车票--校验乘客是否能退票 */
export function kpiBusRefundCheckIsRefund(data = {}) {
  return Request('busmobile/refund/checkIsRefund', 'post', undefined, data)
}

/** 获取汽车票职级列表 */
export function kpiBusRankGetBusRanks(data = {}) {
  return Request('busRank/getBusRanks', 'post', undefined, data)
}

/** 获取汽车票职级详情 */
export function kpiBusRankGetBusRank(data = {}) {
  return Request('busRank/getBusRank', 'post', undefined, data)
}
